module.exports = __webpack_public_path__ + "img/knu_gallery5.aa7c5744.jpg";